import { useState } from "react";
import { useTheme } from "styled-components";
import { Star, StarContainer } from "./styles";
import Start from "../../assets/icons/icon-cool/filled/Star.svg";
import Icon from "../Icon";

const Component = ({ rating, onClick }) => {
    const theme = useTheme() as { [key: string]: { [key: string]: string } }
    const [hoveredStar, setHoveredStar] = useState<number | null>(null);
    const stars = Array.from({ length: 5 }, (_, index) => index + 1);

    return (
        <StarContainer>
            {stars.map((star) => (
            <Star
                key={star}
                onClick={() => onClick(star)}
                onMouseEnter={() => setHoveredStar(star)}
                onMouseLeave={() => setHoveredStar(null)}
            >
                <Icon 
                    icon={Start} 
                    size='4rem'                         
                    color={
                        (hoveredStar !== null && star <= hoveredStar) || (hoveredStar === null && star <= rating)
                            ? theme.colors.Primary
                            : '#ccc'
                    }/>
            </Star>
        ))}
        </StarContainer>
    );
};

export default Component;